import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLoginForm } from '../hooks/useLoginForm';
import { useRegisterForm } from '../hooks/useRegisterForm';
import AuthLayout from '../components/AuthLayout';
import EmailVerification from '../components/EmailVerification';

const AuthPage = ({ mode = 'login' }) => {
  const [isRegister, setIsRegister] = useState(mode === 'register');
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  const loginForm = useLoginForm();
  const registerForm = useRegisterForm();

  const toggleMode = () => {
    setIsRegister((prev) => !prev);
    navigate(isRegister ? '/login' : '/register', { replace: true });
  };

  const form = isRegister ? registerForm : loginForm;

  if (registerForm.requiresVerification) {
    return (
      <AuthLayout>
        <div className="form-eyebrow">Vérification</div>
        <h1>Vérifiez votre email</h1>
        <p className="form-intro">Un code a été envoyé à <strong>{registerForm.registeredEmail}</strong></p>
        <EmailVerification
          email={registerForm.registeredEmail}
          onSuccess={registerForm.handleVerificationSuccess}
          onBack={registerForm.handleBackToRegister}
        />
      </AuthLayout>
    );
  }

  return (
    <AuthLayout>
      <div className="form-eyebrow">{isRegister ? 'Nouveau talent' : 'Espace privé artiste'}</div>
      <h1>{isRegister ? 'Créer un compte' : 'Accès Studio'}</h1>
      <p className="form-intro">
        {isRegister ? 'Rejoignez la scène. Créez votre profil artiste.' : 'Prêt à faire vibrer votre catalogue ? Connectez-vous.'}
      </p>

      <form onSubmit={form.handleSubmit}>
        {isRegister && (
          <label>Nom d’artiste
            <input
              type="text"
              name="name"
              placeholder="Ex : Tsiliva"
              required
              value={form.formData.name}
              onChange={form.handleChange}
            />
          </label>
        )}

        <label>Identifiant artiste / label
          <input
            type="email"
            name="email"
            inputMode="email"
            placeholder="artiste@gmail.com"
            required
            value={form.formData.email}
            onChange={form.handleChange}
          />
        </label>

        <label>Mot de passe{' '}
          {!isRegister && (
            <span className="label-action"><Link to="/forgot-password">OUBLIÉ ?</Link></span>
          )}
          <div className="input-with-action">
            <input
              type={show ? 'text' : 'password'}
              name="password"
              placeholder="••••••••"
              required
              value={form.formData.password}
              onChange={form.handleChange}
            />
            <button type="button" onClick={() => setShow(!show)}>{show ? 'Masquer' : 'Afficher'}</button>
          </div>
        </label>

        {isRegister && (
          <>
            <label className="checkbox-label" style={{ display: 'flex', gap: 8, alignItems: 'flex-start', marginTop: 12 }}>
              <input
                type="checkbox"
                name="telegram_opt_in"
                checked={form.formData.telegram_opt_in}
                onChange={form.handleChange}
              />
              <span>Activer la gestion via Telegram Bot <strong>(Recommandé)</strong></span>
            </label>
            <label className="checkbox-label" style={{ display: 'flex', gap: 8, alignItems: 'flex-start', marginTop: 8 }}>
              <input
                type="checkbox"
                name="accept_cgu"
                checked={form.formData.accept_cgu}
                onChange={form.handleChange}
                required
              />
              <span>J’ai lu et j’accepte les <Link to="/terms" target="_blank" style={{ color: 'var(--crimson)' }}>CGU</Link></span>
            </label>
          </>
        )}

        {!isRegister && (
          <label className="checkbox-label" style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 12 }}>
            <input
              type="checkbox"
              name="remember"
              checked={form.formData.remember}
              onChange={form.handleChange}
            />
            <span>Session persistante</span>
          </label>
        )}

        {form.error && <div className="auth-error" style={{ marginTop: 14 }}>{form.error}</div>}

        <button type="submit" className="button button-crimson form-submit" disabled={form.loading} style={{ width: '100%' }}>
          {form.loading ? 'Connexion…' : form.success ? 'Prêt pour le live' : isRegister ? 'Rejoindre' : 'Entrer en scène'}
          <i className="fa-solid fa-arrow-right" style={{ fontSize: '.7rem' }} />
        </button>
      </form>

      <p className="auth-switch">
        {isRegister ? 'Déjà inscrit ?' : 'Nouveau talent ?'}{' '}
        <button type="button" onClick={toggleMode}>{isRegister ? 'Se connecter' : 'Rejoindre'}</button>
      </p>
    </AuthLayout>
  );
};

export default AuthPage;
